export default `<div class="pill" role="text" part="pill">
    <slot></slot>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
    >
        <g id="icon">
            <path
                id="icon_2"
                d="M9.21345 8.09421C9.20066 8.08231 9.19055 8.06791 9.18382 8.0518C9.17709 8.03568 9.17386 8.01825 9.17439 8.00079C9.17541 7.96589 9.18933 7.93264 9.21345 7.90738L14.1017 3.02009C14.1754 2.94649 14.2338 2.85911 14.2737 2.76294C14.3135 2.66676 14.3341 2.56372 14.3341 2.45961C14.3341 2.3555 14.3136 2.25248 14.2738 2.15629C14.234 2.06009 14.1756 1.9725 14.102 1.89886C14.0284 1.82523 13.941 1.76693 13.8449 1.72707C13.7487 1.6872 13.6456 1.6667 13.5415 1.66667C13.4374 1.66665 13.3343 1.68698 13.2381 1.7268C13.1419 1.76662 13.0545 1.82499 12.9808 1.89859L8.09306 6.78588C8.06816 6.81046 8.03459 6.82427 7.99961 6.82427C7.96463 6.82427 7.93103 6.81046 7.90613 6.78588L3.01837 1.89859C2.86881 1.75418 2.66851 1.67446 2.46061 1.67634C2.25271 1.67821 2.05385 1.76144 1.90691 1.90853C1.75997 2.05561 1.67672 2.25466 1.67505 2.46256C1.67338 2.67046 1.75345 2.87067 1.89801 3.02009L6.78577 7.90738C6.80989 7.93264 6.82378 7.96589 6.8248 8.00079C6.82532 8.01825 6.82213 8.03568 6.8154 8.0518C6.80867 8.06791 6.79856 8.08231 6.78577 8.09421L1.89801 12.9815C1.79991 13.0809 1.72944 13.2041 1.69357 13.339C1.65771 13.474 1.65768 13.6161 1.69351 13.7511C1.73053 13.8846 1.80184 14.0061 1.90036 14.1035C1.99889 14.201 2.12119 14.2712 2.25513 14.3067C2.38907 14.3423 2.52998 14.3422 2.66388 14.3065C2.79777 14.2707 2.91997 14.2006 3.01837 14.103L7.90613 9.21571C7.93103 9.19113 7.96463 9.17732 7.99961 9.17732C8.03459 9.17732 8.06816 9.19113 8.09306 9.21571L12.9808 14.103C13.1304 14.2474 13.3307 14.3271 13.5386 14.3253C13.7465 14.3234 13.9453 14.2399 14.0923 14.0928C14.2392 13.9457 14.3225 13.7469 14.3242 13.539C14.3258 13.3311 14.2458 13.1309 14.1012 12.9815L9.21345 8.09421Z"
                fill="#717171"
            />
        </g>
    </svg>
</div>

<style>
    .pill {
        display: inline-flex;
        align-items: center;
        column-gap: 0.5rem;
        font-family: Asap;
        background-color: var(--svea-pill-bg, #ffffff);
        color: var(--svea-pill-text, #434343);
        border: var(--svea-pill-border, 1px solid #cbcbcb);
        border-radius: var(--svea-pill-border-radius, 0.25rem);
        line-height: var(--svea-pill-line-height, 1.5rem);

        font-size: var(--svea-pill-base-font-size, 1rem);
        padding: var(--svea-pill-base-padding-y, 0.5rem)
            var(--svea-pill-base-padding-x, 1rem);
    }

    div svg {
        display: none;
    }

    button {
        cursor: pointer;
    }

    button.disabled {
        cursor: not-allowed;
    }

    .disabled {
        background-color: var(--svea-pill-disabled-bg, #f1f0eb);
        color: var(--svea-pill-disabled-text, #949494);
    }

    .pill.small {
        font-size: var(--svea-pill-small-font-size, 0.875rem);
        padding: var(--svea-pill-small-padding-y, 0.125rem)
            var(--svea-pill-small-padding-x, 0.5rem);
    }
</style>
`